import Toasts from '../../Toasts';
import Toast from './Toast';
export default Toast;